import React from 'react'
import useClientLocation from '../../../hooks/use-client-location'
import Modal from '../../modals/wrapper'
import { Star } from 'react-bootstrap-icons'
import { Button } from 'react-bootstrap'

const DropExperienceScreen = () => {
    const { goBack, toSchedule, toCatalog } = useClientLocation()
    
    return (
        <Modal
            block='static'
            onHide={goBack}
        >
            <div style={{ padding: '40px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', height: '100%', paddingLeft: '10px', paddingRight: '10px'}}>
                    <div
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}
                    >
                        <Star size={65} />
                    </div>
                    <div
                        style={{ padding: '35px'}}
                        className='text-center'
                    >
                        You have successfully enrolled in this experience.  View all upcoming experiences on your dashboard.
                    </div>
                    <div>
                        <Button
                            block
                            onClick={() => toSchedule()}
                        >
                            VIEW MY EXPERIENCES
                        </Button>
                        <Button
                            block
                            variant='outline-primary'
                            onClick={() => toCatalog()}
                        >
                            ADD MORE EXPERIENCES
                        </Button>
                    </div>
                </div>
            
            </div>
        </Modal>
    )
}

export default DropExperienceScreen